
import { openPopup } from '../modules/Popup.js';

// General code for forms with password fields & enabling submit button when all the required field are filled

jQuery(function($){
    $(`<span class="togglepassword"></span>`).insertAfter($('input[type="password"]'));

    $('.togglepassword').on('click', function(){
        let toggle = $(this);
        if (toggle.hasClass('active')){
            toggle.removeClass('active');
            $(this).siblings('input[name="password"], input[name="password1"], input[name="password2"], input[name="pwd"]').attr('type', 'password');
        }
        else{
            toggle.addClass('active');
            $(this).siblings('input[name="password"], input[name="password1"], input[name="password2"], input[name="pwd"]').attr('type', 'text');
        }
    });


    // Voor elke form
    $('form').each(function(){
        // Logica voor formulier validatie
        let form = $(this);    

        function validateForm (){
            if (formRequiredFilled(form)){
                form.find('input[type="submit"], button[type="submit"]').removeClass('btn--inactive');
            }
            else{
                form.find('input[type="submit"], button[type="submit"]').addClass('btn--inactive');
            }  
        }

        validateForm();
        form.find('input').on('change', validateForm);

        form.find('input[name="page-title"]').val(document.title);  
    });


    // Check of alle verplichte velden zijn ingevuld
    function formRequiredFilled(form){
        let allFilled = true;


        form.find('input[required], input.required, textarea.required, textarea[required]').each(function(){
            let value = $(this).val();

            if (value == ''){
                allFilled = false;
            }
        });

        form.find('.wpcf7-acceptance input').each(function(){
            if (!$(this).is(':checked')){
                allFilled= false;
            }
        });
        return allFilled;
    }


    /* All redirects for all forms */
    document.addEventListener('wpcf7mailsent', function(event) {
        /* if (event.detail.contactFormId == '1671') { 
            openPopup('bedankt-brochure');
        } */
      //  window.location.href = '/bedankt';
        
    }, false);    


    initAddressApi('billing_postcode', 'billing_housenumber', 'billing_address_1', 'billing_city', 'billing_addition', $('.booking__form'));
});


export function initAddressApi(postcode, huisnummer, adres, stad, toevoeging, $form){
    let postcodeInput = $form.find('input[name=' + postcode + ']');
    let huisnummerInput = $form.find('input[name=' + huisnummer + ']');
    let toevoegingInput = $form.find('input[name=' + toevoeging + ']');

    postcodeInput.on('input', detectChange);
    huisnummerInput.on('input', detectChange);
    toevoegingInput.on('input', detectChange);

    function detectChange(){
        if (postcodeInput.val() && huisnummerInput.val()){
            getStreetAndCity(postcodeInput.val(), huisnummerInput.val(), adres, stad, toevoegingInput.val(), $form);
        }
    }
}

function getStreetAndCity(postcode, huisnummer, adres, stad, toevoeging, $form){
    let url = "https://api.bag.kadaster.nl/lvbag/individuelebevragingen/v2/adressen?postcode=" + postcode + "&huisnummer=" + huisnummer;

    jQuery.ajax({
        url: url,
        headers: {"X-Api-Key": "l759f23ec1d6ad46a19db993c25ef1b523"},
        success: function(data){
            if (data._embedded){
                let straatnaam = data._embedded.adressen[0].korteNaam;
                let stadnaam = data._embedded.adressen[0].woonplaatsNaam;

                $form.find('input[name=' + stad + ']').val(stadnaam);
                $form.find('input[name=' + adres + ']').val(straatnaam + ' ' + huisnummer + toevoeging + ', ' + stadnaam);
                $form.find('input[name=' + adres + ']').removeAttr('readonly');
                $form.find('input[name=' + adres + ']').trigger('change');
            }
            else{
                $form.find('input[name=' + stad + ']').val('');
                $form.find('input[name=' + adres + ']').val('Adres niet gevonden');
                $form.find('input[name=' + adres + ']').trigger('change');
            }
            
        }
    });
}
